<template>
  <div class="ExperiseAreaDetail">
    <top-navbar :menu-opened.sync="menuOpened" />
    <app-menu :active.sync="menuOpened" :bottom="true" />
    <page-banner
      image="bg_trabalhista.png"
      :title="expertiseArea.title"
      :icon="expertiseArea.icon"
      :links="links"
    />

    <section class="site-container site-section-v expertise-area-text">
      <div
        class="expertise-area-text-content"
        v-html="expertiseArea.full_text"
      ></div>
      <div class="expertise-area-text-team-members">
        <h3 class="text-orange">Especialistas na Área</h3>

        <div
          class="expertise-area-text-team-member"
          v-for="item in teamMembers"
          :key="`eai-${item.id}`"
        >
          <div class="image">
            <logo-icon :active="true" />
            <img :src="item.image" width="100" />
          </div>
          <h4>{{ item.name }}</h4>
          <p>
            {{ item.text }}
          </p>
          <router-link
            :to="{
              name: 'team_detail',
              params: { slug: item.slug },
            }"
            class="button button-orange is-small is-outlined"
          >
            ENTRAR EM CONTATO
          </router-link>
        </div>
      </div>
    </section>
    <div class="site-container">
      <expertise-area
        :mobile-vertical="true"
        :small="true"
        :items="otherExpertiseAreas"
        title="Outras Áreas de Atuação"
      />
      <hr />
      <form-contact title="Entre em Contato">
        <template #info><contact-info /></template>
      </form-contact>
    </div>

    <section class="site-container">
      <hr />
      <h2 class="text-center text-orange">Últimos Artigos</h2>
      <div class="post-list post-list-mobile-grid-v">
        <div class="post-list-item" v-for="post in posts" :key="post.id">
          <post-card
            :type="post.category"
            :is-square-cover="
              currentCategory && currentCategory.type == 'podcast'
            "
            :post="post"
          />
        </div>
      </div>
      <hr />
    </section>
    <download-app />
  </div>
</template>

<script>
import TopNavbar from "@/components/Page/TopNavbar";
import AppMenu from "@/components/Menu";
import PageBanner from "@/components/Page/Banner";
import ExpertiseArea from "@/components/Home/ExpertiseArea";
import LogoIcon from "@/components/Svg/LogoIcon";
import expertiseAreaItems from "@/data/expertise-area";
import api from "../../services/api";

import FormContact from "@/components/FormContact";
import ContactInfo from "@/components/ContactInfo";
import DownloadApp from "@/components/Home/DownloadApp";
import PostCard from "@/components/Blog/PostCard";

export default {
  components: {
    AppMenu,
    ExpertiseArea,
    TopNavbar,
    PageBanner,
    LogoIcon,
    FormContact,
    ContactInfo,
    DownloadApp,
    PostCard,
  },

  computed: {
    links() {
      return [
        { title: "Áreas de Atuação", to: { name: "page_expertise_area" } },
        {
          title: this.expertiseArea.title,
          to: {
            name: "expertise_area_detail",
            params: { slug: this.expertiseArea.slug },
          },
        },
      ];
    },
  },

  data() {
    return {
      menuOpened: false,
      expertiseArea: {},
      otherExpertiseAreas: [],
      teamMembers: [],
      posts: [],
    };
  },

  watch: {
    $route: {
      immediate: true,
      async handler() {
        const { data: area } = await api.get(
          `areas/${this.$route.params.slug}`
        );

        this.expertiseArea = area.area;

        let areas = [...expertiseAreaItems];
        console.log(areas);
        this.otherExpertiseAreas = area.others_areas;
        this.teamMembers = area.area.team;
        this.posts = area.posts;
        console.log("team", this.teamMembers);
      },
    },
  },
};
</script>

<style>
</style>
